import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CFormCheck, CFormInput, CInputGroup, CInputGroupText } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import { formatUTC } from 'src/store';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import Status from 'src/components/tableElements/Status';
import CustomPagination from 'src/components/pagination/CustomPaginatiion';
import AxiosInstance from 'src/components/Axios';
import ItemControlModalCustom from 'src/components/item_control_modal/ItemControlModalCustom';
import FilterDropdownProjects from 'src/components/projects/FilterDropdownProjects';
import dayjs from 'dayjs'
import ActiveFilters from 'src/components/ActiveFilters';


const tokenStr = localStorage.getItem('user');
const user = localStorage.getItem('user_data');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderProjects() {
  let res = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/projects', {
    params: {
      page: page,
      "language.id": 1,
      'g[0]': 'projects:read',
      'g[1]': 'projects:financed',
      'g[2]': 'projects:partners',
      'g[3]': 'projects:coordinator',
      ...(!Permissions(user, 'Projects', 'SHOW_PROJECTS') && { show: true })
    },
    headers: header.headers
  }


    // , header
  ).then((response) => {
    return response;
  });
  ///
  let res2 = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/projects', {
    params: {
      // page: page,
      pagination: false,
      "language.id": 1,
      'g[0]': 'projects:read',
      'g[1]': 'projects:financed',
      'g[2]': 'projects:partners',
      'g[3]': 'projects:coordinator',
      ...(!Permissions(user, 'Projects', 'SHOW_PROJECTS') && { show: true })
    },
    headers: header.headers
  }).then((response) => {
    return response;
  });

  ///
  // return res;
  return {
    data: res.data,
    allProjects: res2.data
  }
};

const Projects = () => {
  if (!Permissions(user, 'Projects', 'VIEW_PROJECTS')) {
    return <PermissionsNoPage />;
  }

  const { data, allProjects } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);
  // console.log('data', data)
  // console.log('allProjects', allProjects)


  function extractUniqueRelations(data) {

    let allCoordinatorsFromData = [];
    let allFinancedFromData = [];
    let allPartnersFromData = [];


    data['hydra:member'].forEach(elem => {
      if (elem.coordinator.length > 0) {
        allCoordinatorsFromData.push(elem.coordinator)
      }
      if (elem.financed.length > 0) {
        allFinancedFromData.push(elem.financed)
      }
      if (elem.partners.length > 0) {
        allPartnersFromData.push(elem.partners)
      }
    })
    function uniqueById(arr) {
      return arr.filter((item, index, self) => {
        return item?.id && index === self.findIndex(t => t.id === item.id);
      });
    };


    return {
      flatCoordinators: uniqueById(allCoordinatorsFromData.flat()),
      flatFinanced: uniqueById(allFinancedFromData.flat()),
      flatPartners: uniqueById(allPartnersFromData.flat()),
    }

  }

  // стан для модалки видалення і приховування
  const [showItemControlModal, setShowItemControlModal] = useState(false);

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  //актуальна сторінка
  const [currentPage, setCurrentPage] = useState(1);

  //стан для всіх проектів без пагінаціі для побудови випадаючого списку
  const [projects, setProjects] = useState(allProjects['hydra:member'] || [])

  //стан для списку субайтемів
  const [selectedSubItems, setSelectedSubItems] = useState([]);

  //стан  видимості по фільтру
  const [visibilityFilter, setVisibilityFilter] = useState(undefined)

  //стан для статусу проекту(фільтр)
  const [projectsStatus, setProjectsStatus] = useState('')

  //стан для збереження  айді вибраного проекту(фільтр)
  const [projectsId, setProjectsId] = useState(null)

  //стан для  координатор
  const [coordinatorAll, setCoordinatorAll] = useState(
    extractUniqueRelations(allProjects).flatCoordinators ||
    [])
  //айді акаунта координатор для фільтра
  const [coordinatorId, setCoordinatorId] = useState(null)

  //стан для  financed  у всих проектах
  const [financedAll, setFinancedAll] = useState(
    extractUniqueRelations(allProjects).flatFinanced ||
    [])
  //айді акаунта фінансед для фільтра
  const [financedId, setFinancedId] = useState(null)

  //стан для партнерів в усіх проектах
  const [partnersAll, setPartnersAll] = useState(
    extractUniqueRelations(allProjects).flatPartners ||
    [])
  //айді акаунта партнерс для фільтра
  const [partnersId, setPartnersId] = useState(null)

  //стан для дати date_from
  const [dateFrom, setDateFrom] = useState(null)


  //стан для дати date_to
  const [dateTo, setDateTo] = useState(null)

  //
  const [makeRequest, setMakeRequest] = useState(false)

  // стан для компонента активних фільтрів
  const [activeFilters, setActiveFilters] = useState([])

  // console.log('coordinatorAll', coordinatorAll)
  // console.log('financedAll', financedAll)
  // console.log('partnersAll', partnersAll)
  //стан для партнерів в усіх проектах

  //Чи показувати кнопки видалення і приховування в попапі

  const isDelAction = true;
  const isHideAction = true;

  //ефект для відкриття модалки
  useEffect(() => {
    if (selectedIds.length >= 2) {
      setShowItemControlModal(true)
    }
    else {
      setShowItemControlModal(false)
    }
  }, [selectedIds])

  useEffect(() => {
    getAllProjectsWithoutPagination()
  }, [])

  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  };
  //закоментовано
  // const getRowsTable = (p = 1) => {
  //   axios.get(process.env.REACT_APP_SERVER_URL + '/api/projects?language.id=1&page=' + p, header).then((response) => {
  //     setRows(response.data['hydra:member']);
  //   });
  // };


  useEffect(() => {
    if (dateFrom && dateTo) {
      // console.log('request')
      getRowsTable(currentPage)
    } else if (dateFrom === null && dateTo === null && makeRequest === true) {
      getRowsTable(currentPage)
    }
  }, [dateFrom, dateTo, makeRequest])

  useEffect(() => {

    getRowsTable(currentPage);
  }, [currentPage, visibilityFilter, coordinatorId, financedId, partnersId, projectsStatus, projectsId]);


  //параметри атрибутів для фільтра
  const buildFilterParams = () => ({
    'show': visibilityFilter === 'visible' ? true : visibilityFilter === 'non_visible' ? false : null,
    // 'attributeItems': selectedSubItems.map(item => item.id),
    // 'category.id': collectionId
    'id': projectsId,
    'financed.id': financedId,
    'partners.id': partnersId,
    'coordinator.id': coordinatorId,
    'status': projectsStatus ? projectsStatus : null,
    'dateStart[after]': dateFrom ? dayjs(dateFrom)
      // .tz('Europe/Kyiv')
      .format('YYYY-MM-DDTHH:mm:ssZ') : null,
    'dateStart[before]': dateTo ? dayjs(dateTo)
      // .tz('Europe/Kyiv')
      .format('YYYY-MM-DDTHH:mm:ssZ') : null
  });

  const getRowsTable = (p = 1) => {

    const filterParams = buildFilterParams()

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/projects`, {
      params: {
        page: p,
        'language.id': 1,
        'g[0]': 'projects:read',
        'g[1]': 'projects:financed',
        'g[2]': 'projects:partners',
        'g[3]': 'projects:coordinator',
        ...filterParams,
      },
      headers: header.headers,
    })
      .then((response) => {

        // setCoordinatorAll(extractUniqueRelations(response.data).flatCoordinators)
        // setFinancedAll(extractUniqueRelations(response.data).flatFinanced)
        // setPartnersAll(extractUniqueRelations(response.data).flatPartners)

        setRows(response.data['hydra:member']);
        setRowCountState(response.data['hydra:totalItems']);
      })
      .catch((error) => {
        console.error('Помилка:', error);
      });
  };

  //функція для отримання повного списку проектів і наповнення даними випадаючого списку

  function getAllProjectsWithoutPagination() {

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/projects`, {
      params: {
        // page: p,
        'language.id': 1,
        'g[0]': 'projects:read',
        'g[1]': 'projects:financed',
        'g[2]': 'projects:partners',
        'g[3]': 'projects:coordinator',

      },
      headers: header.headers,
    })
      .then((response) => {
        // console.log('response', response)

        setProjects(response.data['hydra:member'])
        setCoordinatorAll(extractUniqueRelations(response.data).flatCoordinators)
        setFinancedAll(extractUniqueRelations(response.data).flatFinanced)
        setPartnersAll(extractUniqueRelations(response.data).flatPartners)

        // setRows(response.data['hydra:member']);
        // setRowCountState(response.data['hydra:totalItems']);
      })
      .catch((error) => {
        console.error('Помилка:', error);
      });
  }


  const handlePageChange = (page) => {
    //
    setCurrentPage(page + 1)
    //
    getRowsTable(page + 1);
  };

  function handleSearch(event) {
    axios.get(process.env.REACT_APP_SERVER_URL + '/api/projects?language.id=1&name=' + event.target.value, header).then((response) => {
      setRows(response.data['hydra:member']);
    });
  }



  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };


  //функція для додавання активних фільтрів в стан
  function handleActiveFilters(filterSlug, filterLabel, optionSlug, optionLabel, optionId) {
    setActiveFilters(prev => {
      const filtered = prev.filter(item => item.filterSlug !== filterSlug);
      return [...filtered, { filterSlug, filterLabel, optionSlug, optionLabel, optionId }];
    })
  }

  //функція для додавання пункту субменю випадайки в стан

  function handleSubItem(id, slug) {
    // console.log(id, 'id', slug, 'slug')
    setSelectedSubItems(prev => {
      const filtered = prev.filter(item => item.slug !== slug);
      return [...filtered, { slug, id }];
    });
  }

  //функція для очистки selectedSubItems
  function cleanListItem(slug) {
    setActiveFilters(
      activeFilters.filter(elem => elem.filterSlug !== slug)
    )
    if ((slug === 'Visibility' && visibilityFilter === 'visible') || (slug === 'Visibility' && visibilityFilter === 'non_visible')) {
      // console.log('not set')
      setVisibilityFilter(undefined)
      return
    }

    else if (slug === 'Projects') {
      setProjectsId(null)
      setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
      return
    }

    else if (slug === 'Status') {
      setProjectsStatus('')
      setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
      return
    }
    else if (slug === 'Financed') {
      setFinancedId(null)
      setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
      return
    }
    else if (slug === 'Partners') {
      setPartnersId(null)
      setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
      return
    }
    else if (slug === 'Coordinator') {
      setCoordinatorId(null)
      setSelectedSubItems(
        selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug)
      )
      return
    }
    else {
      setSelectedSubItems(
        selectedSubItems.filter(elem => elem?.slug !== slug)
      )
    }
  }

  //функція для скидання всих станів 
  function resetAll() {
    // console.log('resetAll')
    setActiveFilters([])
    setSelectedSubItems([])
    setVisibilityFilter(undefined)
    setProjectsStatus('')
    setProjectsId(null)
    setCoordinatorId(null)
    setFinancedId(null)
    setPartnersId(null)
    //  скидання дат
    setDateFrom(null)
    setDateTo(null)
    setMakeRequest(true)
  }

  // function changeVisibilityOfItems(rows, selectedIds) {
  //   confirmAlert({
  //     title: 'Ви впевнені що хочете змінити видимість сторінок ?',
  //     message: '',
  //     buttons: [
  //       {
  //         label: 'Так',
  //         onClick: () => {
  //           console.log('changeVisibility')
  //           const resultItems = selectedIds.map(selectedId => {

  //             return AxiosInstance.put(`/projects/${selectedId}`, { show: rows.find(row => row.id === selectedId)?.show !== undefined ? !rows.find(row => row.id === selectedId)?.show : false })
  //           })

  //           Promise.all(resultItems).then(() => {
  //             getRowsTable()
  //             setSelectedIds([])
  //           })


  //         }
  //       },
  //       {
  //         label: 'Ні',
  //         onClick: () => {
  //           return;
  //         }
  //       }
  //     ]
  //   });
  // }
  function changeVisibilityOfItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете змінити видимість сторінок ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: async () => {
            try {
              const fetchedObjects = await Promise.all(
                selectedIds.map(id =>
                  AxiosInstance.get(`/projects/${id}`).then(res => res.data)
                )
              );
              const updateRequests = fetchedObjects.map(obj =>
                AxiosInstance.put(`/projects/${obj.id}`, {
                  show: obj.show !== undefined ? !obj.show : false,
                })
              );
              await Promise.all(updateRequests);
              getRowsTable(currentPage);
              setSelectedIds([]);
            } catch (error) {
              console.error('Помилка при оновленні видимості:', error);
            }
          },
        },
        {
          label: 'Ні',
          onClick: () => { },
        },
      ],
    });
  }


  function deleteItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете видалити сторінки ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            console.log('delete')
            const resultItems = selectedIds.map(selectedId => {

              return AxiosInstance.delete(`/projects/${selectedId}`)
            })

            Promise.all(resultItems).then(() => {
              getRowsTable(currentPage)
              setSelectedIds([])
              getAllProjectsWithoutPagination()
            })


          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }


  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            AxiosInstance.delete('/projects/' + row.id).then(()=> {
              getRowsTable(currentPage);
              getAllProjectsWithoutPagination();
            }).catch(err => {
              console.log("delete err", err);
            });
            // const deleteMain = () => AxiosInstance.delete('/projects/' + row.id);
            // if (row.translations.length > 0) {
            //   const deletePromises = row.translations.map(translate =>
            //     AxiosInstance.delete('/projects/' + translate.id)
            //   );
            //   Promise.all(deletePromises)
            //     .then(() => deleteMain())
            //     .then(() => {
            //       getRowsTable(currentPage);
            //       getAllProjectsWithoutPagination()
            //     })
            //     .catch(err => {
            //       console.log("delete translations or main err", err);
            //     });
            // } else {
            //   deleteMain().then(() => {
            //       getRowsTable(currentPage);
            //       getAllProjectsWithoutPagination()
            //     })
            //     .catch(err => {
            //       console.log("delete main err", err);
            //     });
            // }
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  function Hidden(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите змінити пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            // змінити всі show у children translations якщо змінюєм батька
            axios.put(process.env.REACT_APP_SERVER_URL + '/api/projects/' + row.id, { show: row.show !== undefined ? !row.show : true }, header).then(() => {
              if (row.translations.length > 0) {
                const updatePromises = row.translations.map(translate =>
                  axios.put(process.env.REACT_APP_SERVER_URL + '/api/projects/' + translate.id, { show: row.show !== undefined ? !row.show : true }, header)
                );

                Promise.all(updatePromises)
                  .then(() => {
                    getRowsTable(currentPage);
                  })
                  .catch(err => {
                    console.log("update show translations err", err);
                  });
              } else {
                getRowsTable(currentPage);
              }
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'name',
      headerName: 'Назва',
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Статус',
      width: 200,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'dateStart',
      headerName: 'Дата створення',
      type: 'datetime',
      width: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{formatUTC(params.row.dateStart)}</div>
      }
    },
    {
      field: 'dateEnd',
      headerName: 'Дата Завершення',
      type: 'datetime',
      width: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{formatUTC(params.row.dateEnd)}</div>
      }
    },
    {
      field: 'showStatus',
      headerName: 'Visibility',
      sortable: true,
      width: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <Status type={params.row.show ? 'visible' : 'hidden'} />
      }
    },
    {
      field: "action",
      headerName: ""
      // "Action"
      ,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      // renderCell: (params) => {
      //   return <Link to={'/projects/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={'/projects/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }

    },
    {
      field: "delete",
      headerName: ''
      //  "Видалити"
      ,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => {
      //     Deleted(params.row)
      //   }
      //   }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }

    },
    {
      field: "showCheckbox",
      headerName: ''
      //  "Відображати"
      ,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      // renderCell: (params) => {
      //   return <CFormCheck id="formCheck" disabled={!Permissions(user, 'Projects', 'HIDE_PROJECTS')} label="" onChange={() => Hidden(params.row)} checked={params.row.show || false} />;
      // }
      renderCell: (params) => {
        return <button disabled={!Permissions(user, 'Projects', 'HIDE_PROJECTS')} className='transparent' onClick={() => Hidden(params.row)}>
          {params.row.show ? <img src="/show.svg" alt="show" /> : <img src="/hidden.svg" alt="hidden" />}
        </button>
      }
    },
  ];

  // console.log('selectedIds', selectedIds)
  // console.log('rows', rows)

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader className='items_card_header'>
            {/* <strong>Проекти</strong> */}
            Projects
            <small></small>
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_with_filter'>
              <p className="text-medium-emphasis small"
                // style={{ order: '2' }}
                style={{ order: '3' }}
              >
                <Link to="/projects/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                  {/* Створити */}
                  Add
                </CButton></Link>
              </p>

              <FilterDropdownProjects
                selectedSubItems={selectedSubItems}
                setSelectedSubItems={setSelectedSubItems}
                coordinatorAll={coordinatorAll}
                setCoordinatorAll={setCoordinatorAll}
                coordinatorId={coordinatorId}
                setCoordinatorId={setCoordinatorId}
                partnersAll={partnersAll}
                setPartnersAll={setPartnersAll}
                partnersId={partnersId}
                setPartnersId={setPartnersId}
                financedAll={financedAll}
                setFinancedAll={setFinancedAll}
                financedId={financedId}
                setFinancedId={setFinancedId}
                visibilityFilter={visibilityFilter}
                setVisibilityFilter={setVisibilityFilter}
                handleSubItem={handleSubItem}
                cleanListItem={cleanListItem}
                getAllProjectsWithoutPagination={getAllProjectsWithoutPagination}
                projects={projects}
                setProjects={setProjects}
                projectsStatus={projectsStatus}
                setProjectsStatus={setProjectsStatus}
                projectsId={projectsId}
                setProjectsId={setProjectsId}
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
                makeRequest={makeRequest}
                setMakeRequest={setMakeRequest}
                resetAll={resetAll}
                handleActiveFilters={handleActiveFilters}
                activeFilters={activeFilters}
              />
              {/* <CFormInput type="search" placeholder='Пошук по назві' onChange={handleSearch} style={{ marginBottom: "10px" }} />
             */}
              <CInputGroup
                className="mb-3 item_add_input_wrapper_round"
                style={{ order: '1' }}
              //  className="mb-3 item_add_input_wrapper"
              // style={{ border: '1px solid #ccc', height: '40px', width: '228px', borderRadius: "12px" }}
              >
                <CInputGroupText style={{ backgroundColor: 'transparent', border: 'none', padding: 0, paddingLeft: '10px' }}>
                  {/* <CIcon icon={cilSearch} /> */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#767781"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CInputGroupText>
                <CFormInput
                  className="item_add_input_round"
                  type="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
              </CInputGroup>
            </div>

            {/* Блок додавання активних фільтрів */}
            {/* <div className='active-filter-attributes'>
              <div className='active-filter-attributes_items'>
                {activeFilters.length > 0 || (dateFrom && dateTo) ? <div className='active-filter-attributes_items_title'>
                  <span>Active Filters:</span>
                </div> : ''}
                {activeFilters.map(elem => {

                  return (
                    <div key={elem.optionId} className='active-filter-item'>
                      <div className='active-filter-item__infoBlock'>
                        <div className='active-filter-item__infoBlock__filterName'>{elem.filterLabel}{' '}:</div>
                        <div className='active-filter-item__infoBlock__attributeName'>{`${elem.filterSlug === 'Projects' ? elem.optionId : elem.optionLabel}`}</div>
                      </div>
                      <div className='active-filter-item__deleteIcon' onClick={() => cleanListItem(elem.filterSlug)}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 5L5 15M5 5L15 15" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    </div>

                  )
                })
                }
                {
                  (dateFrom && dateTo) ?
                    <>
                      <div className='active-filter-item'>
                        <div className='active-filter-item__infoBlock'>
                          <div className='active-filter-item__infoBlock__filterName'>Start date {' '}:</div>
                          <div className='active-filter-item__infoBlock__attributeName'>{`${dayjs(dateFrom).format('YYYY-MM-DD')} to ${dayjs(dateTo).format('YYYY-MM-DD')}`}</div>
                        </div>
                        <div className='active-filter-item__deleteIcon'
                          onClick={() => {
                            setDateFrom(null)
                            setDateTo(null)
                            setMakeRequest(true)
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 5L5 15M5 5L15 15" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </> : ''
                }

              </div>
            </div> */}
            <ActiveFilters
              activeFilters={activeFilters}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              setMakeRequest={setMakeRequest}
              cleanListItem={cleanListItem}
            />
            {/* Блок додавання активних фільтрів (верх)*/}


            <div style={{ height: 600, width: '100%', position: 'relative' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}

                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }

                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}
              />

              <ItemControlModalCustom
                show={showItemControlModal}
                setShow={setShowItemControlModal}
                setSelectedIds={setSelectedIds}
                changeVisibilityOfItems={changeVisibilityOfItems}
                deleteItems={deleteItems}
                selectedIds={selectedIds}
                rows={rows}
                isDelAction={isDelAction}
                isHideAction={isHideAction}

              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow >
  );
};

export default Projects;